module.exports = __webpack_public_path__ + "static/img/html_128.ce6bcfce.png";